var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"content"}},[(_vm.showCanvas)?_c('canvas'):_vm._e(),(!_vm.showCanvas)?_c('div',{staticClass:"noticeText"},[_vm._v("请长按或截图保存")]):_vm._e(),_c('img',{attrs:{"src":"","alt":"","id":"hideImg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }